module.exports = __webpack_public_path__ + "assets/xiwang-silogan.6192c76.png";